import {kmApiLink} from "@pg-mono/km-routes";

import {kmApi} from "@/features/km_app/api/km_api";

import {IApplicationPayload} from "../types/IApplicationPayload";
import {IApplicationResponse} from "../types/IApplicationResponse";

export const postApplicationApi = kmApi.injectEndpoints({
    endpoints: (builder) => ({
        postApplication: builder.mutation<IApplicationResponse, IApplicationPayload>({
            query: (payload) => {
                return {
                    url: kmApiLink.applications.application(),
                    method: "POST",
                    body: payload
                };
            },
            // "Favorites" also covers the investment lists, whose `inquiry_sent` flag this send flips.
            invalidatesTags: ["Application", "Favorites"]
        })
    })
});

export const {usePostApplicationMutation} = postApplicationApi;
import {kmApiLink} from "@pg-mono/km-routes";

import {kmApi} from "@/features/km_app/api/km_api";

import {IApplicationPayload} from "../types/IApplicationPayload";
import {IApplicationResponse} from "../types/IApplicationResponse";

export const postApplicationApi = kmApi.injectEndpoints({
    endpoints: (builder) => ({
        postApplication: builder.mutation<IApplicationResponse, IApplicationPayload>({
            query: (payload) => {
                return {
                    url: kmApiLink.applications.application(),
                    method: "POST",
                    body: payload
                };
            },
            // "Favorites" also covers the investment lists, whose `inquiry_sent` flag this send flips.
            invalidatesTags: ["Application", "Favorites"]
        })
    })
});

export const {usePostApplicationMutation} = postApplicationApi;
